<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import Utils from './common/Utils';
import Bubbles from './common/Bubbles.vue';

@Component({
  components: {
    Bubbles,
  },
})
export default class App extends Vue {
  created(): void {
    // allow language to be set by query parameter (for tests)
    const query = Utils.getQuery();
    if (query.lang) {
      this.$i18n.locale = query.lang;
    }
  }
}
</script>

<template>
  <v-app>
    <v-main>
      <Bubbles />
      <router-view />
    </v-main>
  </v-app>
</template>

<style lang="scss">
@import './styles/app.scss';
@import './styles/editor.scss';
</style>
